import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useQnAContext } from './contexts/QnAContext';

export function QnAErrorAlert() {
  const {
    error, isRetrying, retryLastAction, dismissError,
  } = useQnAContext();

  if (!error) {
    return null;
  }

  return (
    <Alert variant="danger" className="mb-2" dismissible onClose={dismissError}>
      <div className="d-flex justify-content-between align-items-start">
        <div className="flex-grow-1 me-2">
          <strong>Error:</strong>
          {' '}
          {error}
        </div>
        <Button
          variant="outline-danger"
          size="sm"
          onClick={retryLastAction}
          disabled={isRetrying}
          className="ms-2"
        >
          {isRetrying ? 'Retrying...' : 'Retry'}
        </Button>
      </div>
    </Alert>
  );
}
